import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { loginCall } from '../../../Infrastructure/Services/AuthService';
import './LoginPage.css';

function LoginPage({ setLoggedIn }) {
  const [email, setemail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    if (!email || !password) { toast.error('Please fill in all fields'); return; }
    setLoading(true);
    try {
      const result = await loginCall(email, password);
      if (result?.data?.token) {
        setLoggedIn(true);
      } else {
        toast.error(result?.error || 'Login failed. Check your credentials.');
      }
    } catch {
      toast.error('Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-box">
        <div className="login-logo">
          <p className="login-subtitle">Game Import Management Platform</p>
        </div>

        <div className="login-card">
          <p className="login-card-label">Sign in to continue</p>

          <div className="login-field">
            <label className="login-field-label">Email</label>
            <input
              className="login-input"
              type="text"
              placeholder="Enter email"
              value={email}
              onChange={e => setemail(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && handleLogin()}
              autoFocus
            />
          </div>

          <div className="login-field">
            <label className="login-field-label">Password</label>
            <input
              className="login-input"
              type="password"
              placeholder="Enter password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && handleLogin()}
            />
          </div>

          <button
            className="btn btn-fadeblack w-100 mt-2"
            onClick={handleLogin}
            disabled={loading}
          >
            {loading
              ? <><span className="spinner-border spinner-border-sm me-2" />Signing in…</>
              : 'Sign In'
            }
          </button>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
